import { RootState } from '../../store';

export const getCurrentUserSelector = (state: RootState) => state.auth.user;
export const getAccessTokenSelector = (state: RootState) => state.auth.accessToken;
export const isCurrentUserAdminSelector = (state: RootState) => state.auth.isAdmin;
export const isCurrentUserSuperAdminSelector = (state: RootState) => state.auth.isSuperAdmin;
export const getLoadingUserSelector = (state: RootState) => state.auth.isLoading;
